import * as React from 'react';

import Dialog from '@mui/material/Dialog';

import DialogContent from '@mui/material/DialogContent';

import DialogTitle from '@mui/material/DialogTitle';
import StatusContext from '../../../contexts/StatusContext'
import AuthContext from "../../../contexts/AuthContext.js";
import AITestContext from "../../../contexts/AITestContext.js";

import { PushButton } from '../pushbutton/PushButton';
import axios from 'axios'
import { config } from "../../../config";

import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { ProgressIcon } from '../customicons/ProgressIcon';

export const  ConnectedAccountDialog = () => {
  
    const {
        changeLanguage,
        isLoading,
        setIsLoading,
        showcreateconnectaccountdialog,
        setShowCreateConnectAccountDialog,
    } = React.useContext(StatusContext);

    const {
      currentUser,
  } = React.useContext(AuthContext);

  const {
    onVerifyIdentity,
    connectedAccount,
    setConnectedAccount,
    //verifyaccount,
} = React.useContext(AITestContext);


    const handleCreateAccount = async (e) =>{
      console.log("handleCreateAccoint-connectedAccount:", connectedAccount)
    
      let tempaccount =connectedAccount;

      if (connectedAccount.account === "")
      {
        console.log("There is no account. Create a new account")
     
          setIsLoading(true)

          let account = ''

          try {
              const res = await axios.post(config.url.API_URL + "/deda_ai_api/purchasetest/createconnectedaccount", {currentUser},{
                      withCredentials:true
                  })
              account = res.data.account
              console.log("CreateConnectedAccount:", account)
            
          } catch(err)
          {
              console.log("Error:", err)
              setIsLoading(false)
              return
          }

        try {
            
         tempaccount = {
              account: account,
              verified: false
          }
          console.log("TempAccount 1:", tempaccount)
            
          let connectedaccount = JSON.stringify(tempaccount)
          

          await axios.post(config.url.API_URL + "/deda_ai_api/purchasetest/saveconnectedaccount", {currentUser, connectedaccount},{
                    withCredentials:true
            })

          setConnectedAccount(tempaccount);
          
        } catch(err)
        {
            console.log("Error:", err)
            return
        }

        setIsLoading(false)
      }

      //verify account
      console.log("TempAccount:", tempaccount)
      onVerifyIdentity(tempaccount)
   
      handleClose()

    }

    


  const handleClose = () => {
    setShowCreateConnectAccountDialog(false);
  };

  return (
    <React.Fragment>
      
      <Dialog
        open={showcreateconnectaccountdialog}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: (event) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries(formData.entries());
            const email = formJson.email;
            console.log(email);
            handleClose();
          },
        }}
      >
        <DialogTitle >{changeLanguage('aitest', 'createaccounttitle')}</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      
        <DialogContent>
        <ProgressIcon isLoading={isLoading} /> 
         
          <h6 style={{ color: 'rgb(138, 57, 57)'}}>{changeLanguage('aitest', 'startreceivingpayments')}</h6>
          <br></br>
          <h6 style={{ color: 'rgb(138, 57, 57)'}}>{changeLanguage('aitest', 'accountverificationtext')}</h6>
          <br></br>
        
          <br></br>
          <PushButton label={changeLanguage('aitest', 'createaccountbutton')} onClick={handleCreateAccount}/>
          <br></br>
       
        </DialogContent>
        {/*
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit">Subscribe</Button>
          <PushButton label="Login"/>
        </DialogActions>
        */}
 
      </Dialog>

      

    </React.Fragment>
    
  );
}